var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bookmarks-container pb-3" }, [
    _vm.isLoading
      ? _c("div", [_c("generic-loading-skeleton")], 1)
      : _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm.isErrored
            ? _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                    "\n    "
                )
              ])
            : _c("div", [
                _vm.bookmarksExist
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.bookmarks.slice(0, 5), function(bookmark) {
                          return _c(
                            "div",
                            {
                              key: bookmark.id,
                              staticClass: "bookmark-entry pb-16-px pl-1"
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: bookmark.url,
                                    target: _vm.getBookmarkTarget(bookmark.url)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleBookmarkClick(bookmark)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "bookmark-icon mr-2",
                                          attrs: { icon: ["fas", "bookmark"] }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "bookmark-link-title" },
                                      [_vm._v(_vm._s(bookmark.title) + " ")]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.bookmarksExist
                          ? _c(
                              "div",
                              {
                                staticClass: "text-nowrap mt-1",
                                on: {
                                  click: function($event) {
                                    return _vm.trackViewAllClick(
                                      "View all bookmarks selected"
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "view-all-link",
                                    attrs: { to: { name: "bookmarks-page" } }
                                  },
                                  [_c("span", [_vm._v("View all")])]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _c(
                      "div",
                      { staticClass: "mt-2 pb-3 no-bookmarks-block d-flex" },
                      [
                        _c(
                          "div",
                          [
                            _c("font-awesome-icon", {
                              staticClass: "info-circle",
                              attrs: { icon: ["fas", "info-circle"] }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
              ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-2" }, [_c("h2", [_vm._v("Bookmarks")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "my-2 no-bookmarks-title" }, [
        _vm._v(
          "\n            Bookmark or Follow pages to get started\n          "
        )
      ]),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52b2a5ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b2a5ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/Bookmarks.vue
// module id = null
// module chunks = 